import * as types from '../../lib/actionTypes.es6';

export const initialState = {
  errors: null,
  openClaimList: null,
  loader: false,
};

export default function openClaimReducer(state = initialState, action) {
  switch (action.type) {
    case types.OPEN_CLAIM_REQUEST:
      return { ...initialState, loader: true };

    case types.OPEN_CLAIM_SUCCESS:
      return { ...state, openClaimList: action.payload, loader: false };

    case types.OPEN_CLAIM_FAILURE:
      return {
        ...state,
        loader: false,
        errors: action.payload,
        openClaimList: null,
      };

    case types.USER_LOGOUT:
      return initialState;

    default:
      return state;
  }
}
